import React, {useEffect, useState} from 'react';

import { useParams } from "react-router";
import Loading from "components/Loading";
import { UsersEdit } from "components/UsersSelect";

import { getIndicatorUser } from "services/Indicators.service";


export default function FormResponsible() {
    const {id} = useParams()

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true)
            const response = await getIndicatorUser(id)
            if (response) {
                setUsers(response)
            }
            setLoading(false)
        })()
    }, [])

     if (loading) return <Loading/>

    return (
        <div className="p-4">
            <UsersEdit indicatorId={id} usersIndicator={users} />
        </div>
    )
}
